import { Gcms_Post } from '@ep/types/gatsbyTypes';
import escapeDoubleQuotes from '@ep/utils/escapeDoubleQuotes';
import React from 'react';
export interface PostMarkupModuleProps {
  post: Gcms_Post;
}

function PostMarkupModule({post}: PostMarkupModuleProps) {  

  const imageUrl        = post.logoImage ? post.logoImage.url : post.featuredImage ? post.featuredImage.url : "/images/fullLogoBlue.png";
  const hasAuthor       = post.author ? true : false;
  const postType        = post.postType === 'Blog' ? 'BlogPosting' : 'NewsArticle';
  const authorName      = hasAuthor ? post.author.name : 'Entertainment Partners';
  const authorType      = hasAuthor ? post.author.name === 'Entertainment Partners' ? 'Organization' : 'Person' : 'Organization';
  const associatedMedia = post.postType === 'Master_Series' && post.logoImage && post.logoImage.vidyardLink ? '"associatedMedia":{"@type":"mediaObject","url":"' + post.logoImage.vidyardLink.replace('.jpg','') + '"},' : '' ;
  const structuredData = '{"@type":"' + postType + '",' +
                           '"image":"' + imageUrl + '",' +
                           associatedMedia +
                           '"author":{"url":"https://www.ep.com/expert-advice/",' +
                           '"name":"' + authorName + '",' + 
                           '"@type":"' + authorType + '"},' + 
                           '"@context":"https://schema.org",' + 
                           '"headline":"' + escapeDoubleQuotes(post.title) + '",' + 
                           '"publisher":{"logo":{"url": "/images/fullLogoBlue.png",' +
                           '"@type":"ImageObject"},' +
                           '"name":"Entertainment Partners",' +
                           '"@type":"Organization"},' + 
                           '"description":"' + escapeDoubleQuotes(post.description) + '",' + 
                           '"datePublished":"' + post.displayDate + '",' + 
                           '"mainEntityOfPage":{ "@id":"https://www.ep.com/' + post.slug + '",' + 
                           '"@type":"WebPage"}}';
  return (
      <script id="post-markup" type="application/ld+json">
        {structuredData}
      </script>
  );
}
export default React.memo(PostMarkupModule);
